var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.182 10.799-1.026 2.446 4.849 4.849 2.446-1.026A14 14 0 0 0 22.035 4l-.02-1.767-1.766-.02A14 14 0 0 0 7.182 10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.702 5.77-.69-.115a7 7 0 0 0-6.1 1.955l-.281.281 3.535 3.536M18.48 13.548l.115.69a7 7 0 0 1-1.955 6.1l-.281.281-3.536-3.535M14.945 3.649 20.6 9.305"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.53,
    cy: 10.72,
    r: 1.859,
    transform: "rotate(45 13.53 10.72)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m5.813 18.437-3.829 3.829M3.691 16.316l-1.828 1.828M7.934 20.559l-1.828 1.828"
  }))));
};
export default SvgRocket;